<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable">
    <mat-card-header>
        <mat-card-title>{{ 'FileSharing.Title' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if (fileShares.length > 0) {
            <table mat-table [dataSource]="fileShares">
                <ng-container matColumnDef="fileName">
                    <th mat-header-cell *matHeaderCellDef>{{ 'FileSharing.FileName' | translate }}</th>
                    <td mat-cell *matCellDef="let item">
                        <a href="{{ getDownloadUrl(item) }}">
                            <mat-icon class="file-symbol">{{ getFileSymbol(item.fileName) }}</mat-icon>
                            {{ item.fileName }}
                        </a>
                    </td>
                </ng-container>
                <ng-container matColumnDef="createdByUserUsername">
                    <th mat-header-cell *matHeaderCellDef>{{ 'FileSharing.CreatedBy' | translate }}</th>
                    <td mat-cell *matCellDef="let item">{{ item.createdByUserUsername }}</td>
                </ng-container>
                <ng-container matColumnDef="expiresByUtc">
                    <th mat-header-cell *matHeaderCellDef>{{ 'FileSharing.ExpiresBy' | translate }}</th>
                    <td mat-cell *matCellDef="let item">{{ item.expiresByUtc | localizedDate }}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let item">
                        <button mat-icon-button (click)="removeFile(item.id)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        } @else {
            {{ 'FileSharing.NoShares' | translate }}
        }
    </mat-card-content>
    <mat-card-actions>
        @if (canUpload) {
            <button mat-button (click)="addFile()">
                <mat-icon>cloud_upload</mat-icon>
                {{ 'FileSharing.Upload' | translate }}
            </button>
        }
    </mat-card-actions>
</mat-card>
